module.exports = __webpack_public_path__ + "img/NEW-FULL-HYBRID-E-TECH.4db43f0b.png";